var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-overlay',[_c('rkm-layout-body',{attrs:{"title":"Assistência social"}},[(_vm.loaded)?_c('rkm-layout-content',[_c('List',{attrs:{"data":{ initials: _vm.initials, form: _vm.form, model: _vm.model, additionals: _vm.additionals }}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }